import * as React from 'react';
import { ComboBox, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../services/api';

type Props = {
    callbackFromParent: (data: TeacherSearchResult) => void;
    className?: string;
    style?: {};
};

type State = {
    defaultValue: TeacherSearchResult | null;
    loading: boolean;
    opened: boolean;
    teacherResults: TeacherSearchResult[];
}

export interface TeacherSearchResult {
    TeacherId: number;
    TeacherName: string;
}

export default class TeacherComboBox extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            defaultValue: null,
            loading: false,
            opened: false,
            teacherResults: [],
        };

        this.getTeachers();
    };

    onChange = (event: ComboBoxChangeEvent) => {
        this.props.callbackFromParent(event.target.value);
    }

    private getTeachers() {
        fetchApi('api/Teacher/List', {}, 'POST')
            .then((data: TeacherSearchResult[]) => {
                let _defaultSelectedTeacher: TeacherSearchResult | undefined;
                const localStorageTeacherId = localStorage.getItem("TEACHER_ID");
                if (localStorageTeacherId) {
                    _defaultSelectedTeacher = data.find(x => x.TeacherId === parseInt(localStorageTeacherId))
                }

                this.setState({
                    defaultValue: _defaultSelectedTeacher || null,
                    teacherResults: data,
                    loading: false
                });

                if (_defaultSelectedTeacher) {
                    this.props.callbackFromParent(_defaultSelectedTeacher);
                }
            });
    }

    public render() {
        return (
            <ComboBox
                defaultValue={this.state.defaultValue}
                data={this.state.teacherResults}
                onChange={this.onChange}
                loading={this.state.loading}
                style={this.props.style}
                className={this.props.className}
                allowCustom={true}
                placeholder="Teacher"
                suggest={true}
                textField="TeacherName"
            />
        );
    }
}
